import type { BeneficiaryKind } from '@mnc/contracts';

/** URL state of the beneficiaries list (kind tab, filters, sort, page, analytics strip). */
export interface BeneficiarySearch {
  kind?: BeneficiaryKind;
  q?: string;
  type?: string;
  region?: string;
  size?: string;
  office?: string;
  nationality?: string;
  gender?: 'male' | 'female';
  program?: string;
  enrolled?: '1' | '0';
  linked?: '1';
  min_lc?: number;
  sort?: string;
  page?: number;
  analytics?: '1';
}

const str = (v: unknown): string | undefined => (typeof v === 'string' && v.trim() ? v : undefined);
const flag = (v: unknown): '1' | undefined => (v === '1' || v === 1 || v === true ? '1' : undefined);

export function parseBeneficiarySearch(raw: Record<string, unknown>): BeneficiarySearch {
  const page = Number(raw.page);
  const minLc = Number(raw.min_lc);
  const kind = str(raw.kind);
  const enrolled = str(raw.enrolled);
  const gender = str(raw.gender);
  return {
    kind: kind === 'organisation' || kind === 'individual' ? kind : undefined,
    q: str(raw.q),
    type: str(raw.type),
    region: str(raw.region),
    size: str(raw.size),
    office: str(raw.office),
    nationality: str(raw.nationality),
    gender: gender === 'male' || gender === 'female' ? gender : undefined,
    program: str(raw.program),
    enrolled: enrolled === '1' || enrolled === '0' ? enrolled : undefined,
    linked: raw.linked === '1' || raw.linked === 1 || raw.linked === true ? '1' : undefined,
    min_lc: Number.isFinite(minLc) && minLc > 0 ? minLc : undefined,
    sort: str(raw.sort),
    page: Number.isInteger(page) && page > 1 ? page : undefined,
    analytics: flag(raw.analytics),
  };
}

/** URL state of the goods & services page. */
export interface ClassificationSearch {
  tab?: 'isic' | 'csi' | 'lc' | 'imports';
  q?: string;
}

export function parseClassificationSearch(raw: Record<string, unknown>): ClassificationSearch {
  const tab = str(raw.tab);
  return { tab: tab === 'isic' || tab === 'csi' || tab === 'lc' || tab === 'imports' ? tab : undefined, q: str(raw.q) };
}
